import { getFunctions, httpsCallable } from "firebase/functions";
import app from "../firebaseConfig";

const functions = getFunctions(app);

export async function openCheckout(): Promise<void> {
  const createCheckoutSession = httpsCallable(
    functions,
    "createCheckoutSession",
  );
  const result = await createCheckoutSession({});
  const { url } = result.data as { url: string };
  if (url) {
    window.location.href = url;
  }
}

export async function openCustomerPortal(): Promise<void> {
  const createCustomerPortal = httpsCallable(functions, "createCustomerPortal");
  const result = await createCustomerPortal({});
  const { url } = result.data as { url: string };
  if (url) {
    window.location.href = url;
  }
}
